import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { soporte } from '../models/soporte';

const ELEMENT_DATA: soporte[] = [
  { descripcion: 'desc1', estado: 1, fecha: '2020/12/19', prioridad: 1, titulo: 'titulo1' },
  { descripcion: 'desc2', estado: 1, fecha: '2020/12/18', prioridad: 1, titulo: 'titulo12' },
  { descripcion: 'desc3', estado: 1, fecha: '2020/12/17', prioridad: 1, titulo: 'titulo3' },
  { descripcion: 'desc4', estado: 1, fecha: '2020/12/16', prioridad: 1, titulo: 'titulo4' },
  { descripcion: 'desc5', estado: 1, fecha: '2020/12/15', prioridad: 1, titulo: 'titulo5' },
  { descripcion: 'desc6', estado: 1, fecha: '2020/12/14', prioridad: 1, titulo: 'titulo6' },
  { descripcion: 'desc7', estado: 1, fecha: '2020/12/13', prioridad: 1, titulo: 'titulo7' },
  { descripcion: 'desc8', estado: 1, fecha: '2020/12/12', prioridad: 1, titulo: 'titulo8' },
  { descripcion: 'desc9', estado: 1, fecha: '2020/12/11', prioridad: 1, titulo: 'titulo9' },
];

@Component({
  selector: 'app-soportepage',
  templateUrl: './soportepage.component.html',
  styleUrls: ['./soportepage.component.scss'],
})
export class SoportepageComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];

  constructor() {
    //  this.dataSource = ELEMENT_DATA;
    this.dataSource = new MatTableDataSource(ELEMENT_DATA);
    this.displayedColumns = ['titulo', 'fecha', 'prioridad', 'estado','descripcion'];
  }

  ngOnInit(): void {}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
